/**
  * @function evalute - evaluate bulkEditSearchBehavior
  *
  * This behavior searches contentIndexes of form types specified in formTypeIdentifiers
  * for a string passed in search with results sorted by sort.  The search uses queryFormBehavior
  *
  * Returns an object with 1 entry per found result. Object is keyed on the found result id.  Each
  * key has a content property that contains another object with field/value pairs
  *
  * The entries returned are designed to feed into the ipad cabinet rows.
  *
  * Example:
  * {
  *   'bc324659-d4ba-4228-9b9c-d032bd219990': {
  *                                   content: {
  *                                       'diameter':'25',
  *                                       'stage':'Stage 1',
  *                                   },
  *                                   'id':'',
  *    },
  *    '00a1fa87-2295-4e8a-85e1-0221d30fac32': {
  *                                   content: {
  *                                       'diameter':'36',
  *                                       'coating':'Coating 1',
  *                                       'stage':'Stage 2',
  *                                   },
  *                                   'id':'',
  *     }
  * }
  *
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const search = await sourceEvaluator(source.search);
  const formTypeIdentifers = await sourceEvaluator(source.formTypeIdentifiers);
  const contentIndexes = await sourceEvaluator(source.contentIndexes);
  const sort = await sourceEvaluator(source.sort);
  if (formTypeIdentifers === undefined || contentIndexes === undefined) {
    return undefined;
  }
  if (typeof search === 'string' && (search.length === 0 || search === null || search === undefined)) {
    return {};
  }

  // perform search
  const queryFormSource = {
    type: 'queryFormBehavior',
    formTypeIdentifiers: formTypeIdentifers,
    sort,
    indexes: contentIndexes,
    search
  };
  const queryFormResult = await sourceEvaluator(queryFormSource);
  const result = {};
  queryFormResult.forEach(form => {
    const id = form.id,
      map = form.map;
    result[id] = {
      content: map,
      id
    };
  });
  return result;
};
module.exports = {
  evaluate
};